export const RichContent = ({ html }) => {
  return (
    <div className="container gap-12 px-4 mx-auto md:w-9/12 ">
      <div
        className="max-w-full redactor"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  )
}
